<template>
  <div class="input flex p-0 rounded relative w-full">
    <div class="flex-grow">
      <input
        type="text"
        class="p-3 bg-transparent"
        :value="value"
        @input="$emit('input', $event.target.value)"
        maxlength="7"
        :disabled="disabled"
      />
    </div>
    <div class="flex-shrink flex -ml-20">
      <div class="w-10 h-full flex-no-shrink" :style="{'background-color': value}" />
      <button @click.stop="showPicker = !showPicker" class="p-3 bg-grey flex-shrink" v-if="!disabled">
        <i class="fas fa-eye-dropper"></i>
      </button>
    </div>
    <div
      class="absolute pin-t pin-r mt-12 z-20 flex-shrink"
      @click.stop
      v-if="showPicker"
    >
      <chrome-picker
        :value="value"
        :disableAlpha="true"
        :disableFields="true"
        @input="value => $emit('input', value.hex)"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'ColourPickerInput',

  props: {
    value: {},
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      showPicker: false
    }
  },

  created () {
    document.addEventListener('click', () => { this.showPicker = false })
  },

  beforeDestroy () {
    document.removeEventListener('click', () => { this.showPicker = false })
  }
}
</script>
